<template>
    <div class="flex items-center justify-between mb-8 space-x-4 w-full">
        <slot />
        <div class="text-2xl uppercase font-extrabold" v-if="title?.length">
            {{ title }}
        </div>
        <div class="flex-1" />
        <close-button @click="close" class="pr-1" />
    </div>
</template>

<script>
    import CloseButton from '../buttons/CloseButton.vue';

    export default {
        name: 'PanelHeader',
        components: {
            CloseButton,
        },
        props: {
            title: {
                type: String,
                required: false,
            },
        },
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>